import React from 'react';
import MaterialCard from '@material-ui/core/Card';
import '../styles/Card.scss';


const Card = (props) => {
    return (
        <MaterialCard className="card" elevation={0} square={true} {...props}>
            {props.children}
        </MaterialCard>
    );
};

export default Card;
